// extracted by mini-css-extract-plugin
module.exports = {"branding":"Branding_branding__ETGO1","sponsoredBy":"Branding_sponsoredBy__CUJ6E"};